module.exports = "lightbulb"